// extracted by mini-css-extract-plugin
export var hostnameInfo = "HostnameCheck-module--hostnameInfo--3Yvbs";